/**
 * Centralized support links used across all translations
 * Update links here to apply changes to all languages
 */
export const SUPPORT_LINKS = {
  /**
   * Application Support Request form in Chevron IT Service Portal
   * This link is the SAME for all environments (dev/test/prod)
   */
  serviceNowRequestForm:
    'https://chevron.service-now.com/mychevron?id=sc_cat_item_guide&sys_id=9c08a21edb126450182e1dca48961981&sysparm_u_appid=1500000886',
} as const;

/**
 * Helper function to build an HTML link with consistent attributes
 * @param url - The URL to link to
 * @param text - The link text to display
 * @returns HTML anchor tag string
 */
export function buildSupportLink(url: string, text: string): string {
  return `<a class="support-link" href="${url}" target="_blank" rel="noopener">${text}</a>`;
}
